// ZonesMapPage Constants
export const CONSTANTS = {
  garage: {
    active: {
      colour: '#1082EA',
      index: 1,
      Fixter: {
        colour: '#1082EA',
        index: 4,
      },
      'GarageC&D': {
        colour: '#FFCA3A',
        index: 3,
      },
      'CustomerC&D': {
        colour: '#DD1FA8',
        index: 2,
      },
    },
    suspended: {
      colour: '#9e9e9e',
      index: 5,
    },
    deleted: {
      colour: '#FF5858',
      index: 6,
    },
  },
  driver: {
    active: {
      colour: '#00B67A',
      index: 8,
    },
    suspended: {
      colour: '#FF9900',
      index: 7,
    },
  },
  'zone-sectors': {
    colour: '#ffffff',
    index: 1,
  },
  'marketing-districts': {
    colour: '#000000',
    index: 1,
  },
};
